<script setup lang="ts">
import { ProposedDelivery } from '@nuts/auto-delivery-sdk';

import ThemedButton from '@/components/base/ThemedButton.vue';

defineProps<{ delivery: ProposedDelivery; location: string }>();

const emit = defineEmits(['handle-close']);

const handleClose = () => emit('handle-close');
</script>

<template>
  <div class="flex flex-col items-center w-full pt-6 pb-0 sm:pb-6">
    <img alt="success" aria-hidden="true" src="@/assets/package-thumbs-up-delivery.svg" />
    <span class="mt-6 text-xl font-semibold sm:text-3xl font-sofia-pro">Success</span>
    <p class="mt-3 text-sm leading-6 sm:text-lg escape-legacy" id="upsell-success-title">
      Added to your next Auto-Delivery!
    </p>
    <div class="flex flex-col w-full mt-10 sm:mt-14 sm:w-72">
      <ThemedButton
        class="h-11"
        data-promo="1"
        :data-promo-creative="`${location}-Continue Shopping`"
        data-promo-name="Auto Delivery: Impulse Upsell"
        fullWidth
        theme="gray"
        type="button"
        @click.prevent="handleClose"
      >
        Continue Shopping
      </ThemedButton>
      <a
        class="mt-2 sm:mt-4 hover:no-underline"
        data-promo="1"
        :data-promo-creative="`${location}-Manage Auto-Delivery`"
        data-promo-name="Auto Delivery: Impulse Upsell"
        :href="`/account/auto-delivery/details/${delivery.id}`"
      >
        <ThemedButton fullWidth tabindex="-1" theme="white" type="button">
          Manage
          <img
            class="sm:h-4 h-3.5 ml-1 mt-0.5"
            alt="Auto Delivery"
            src="@/assets/auto-delivery/logo-gray.svg"
          />
        </ThemedButton>
      </a>
    </div>
  </div>
</template>
